/* eslint-disable react/prop-types */
import { KeenIcon } from '@/components';

/**
 * Client Portal settings card (OL-196). Guests the firm shares matter files
 * with see the OAK Legal menu greyed out, as a preview of the platform. This
 * switch hides those greyed items. A missing key counts as shown — the
 * backend treats it the same way.
 *
 * The settings endpoint requires the firm's core fields on every save, so the
 * toggle resends them unchanged alongside the flag (as AI Features does).
 */
const AdvancedSettingsClientPortal = ({ data, onConfirm, loadData, loadDataSave }) => {
  const showFeatures = data ? data.client_portal_hide_oak_features !== true : true;
  const busy = loadData || loadDataSave || !data;

  const handleToggle = () => {
    if (busy) return;

    const formData = new FormData();
    formData.append('legal_business_name', data.legal_business_name ?? '');
    formData.append('country', data.country ?? '');
    formData.append('date_format', data.date_format ?? '');
    formData.append('time_format', data.time_format ?? '');
    formData.append('client_portal_hide_oak_features', showFeatures ? '1' : '0');
    formData.append('_method', 'PUT');
    onConfirm(formData);
  };

  return (
    <div className="card">
      <div className="card-header" id="advanced_settings_client_portal">
        <h3 className="card-title">Client Portal</h3>
      </div>
      <div className="card-body lg:py-7.5">
        <div className="flex items-center justify-between gap-4">
          <div className="flex items-start gap-3">
            <KeenIcon icon="eye" className="text-lg text-primary mt-0.5" />
            <div className="flex flex-col gap-1">
              <span className="text-sm font-medium text-gray-900">Show OAK Legal features to guests</span>
              <span className="text-xs text-gray-500 max-w-[520px]">
                Guests you share matter files with see the OAK Legal menu greyed out, with a link to learn
                about the platform. Turn this off to show them only their shared matters.
              </span>
            </div>
          </div>

          <label className="switch shrink-0">
            <input
              type="checkbox"
              checked={showFeatures}
              onChange={handleToggle}
              disabled={busy}
              aria-label="Show OAK Legal features to client portal guests"
            />
          </label>
        </div>
      </div>
    </div>
  );
};

export { AdvancedSettingsClientPortal };
